import { render } from "./Open.vue?vue&type=template&id=24b53cf0&scoped=true&ts=true"
import script from "./Open.vue?vue&type=script&lang=ts"
export * from "./Open.vue?vue&type=script&lang=ts"

import "./Open.vue?vue&type=style&index=0&id=24b53cf0&scoped=true&lang=less"
import "./Open.vue?vue&type=style&index=1&id=24b53cf0&lang=less"

import exportComponent from "D:\\work\\risfond-branchmanagementsystem\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24b53cf0"]])

export default __exports__